import {axiosInstances} from './index'

export const getCreditLineDetail = (phone) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/lender/creditline/details`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const createPaymentSession = (amount,file) => {
  let data = new FormData();
  data.append('file', file);
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/lender/payment/session?amount=${amount}`,data).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const createClearDuesSession = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/lender/cleardues/session`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const uploadChallanFile = (id, file) => {
  return new Promise(async(resolve, reject) => {
  	let data = new FormData();
  	data.append('file', file);
  	
    await axiosInstances.api.post(`/finBox/${id}/confirm`, data).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

